import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AuthState, AuthResponse, UserRole, User, AuthError } from './types'

const initialState: AuthState = {
  isAuthenticated: false,
  tokens: null,
  user: {} as User,
  userRole: 'teamMember',
  loading: false,
  error: null,
  loadingMessage: 'Redirecting to Google...',
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginRequest: (state, action: PayloadAction<string>) => {
      state.loading = true
      state.error = null
      state.loadingMessage = action.payload
    },
    loginSuccess: (state, action: PayloadAction<AuthResponse>) => {
      state.isAuthenticated = true
      state.tokens = action.payload.tokens
      state.user = action.payload.user
      state.userRole = getUserRole(action.payload.user.teamMemberInfo.jobProfile)
      state.loading = false
      state.error = null
    },
    loginFailure: (state, action: PayloadAction<AuthError>) => {
      state.isAuthenticated = false
      state.user = {} as User
      state.userRole = 'teamMember'
      state.loading = false
      state.error = action.payload
    },
    logout: (state) => {
      state.isAuthenticated = false
      state.user = {} as User
      state.userRole = 'teamMember'
      state.loading = false
      state.error = null
    },
  },
})

export const { loginRequest, loginSuccess, loginFailure, logout } = authSlice.actions

const getUserRole = (jobProfile: string): UserRole => {
  return jobProfile === 'General Administration Analyst' ||
    jobProfile === 'Applications Development Project Lead' ||
    jobProfile.includes('Leader') ||
    jobProfile.includes('Manager')
    ? 'admin'
    : 'teamMember'
}

export default authSlice.reducer
